const initSwiperNewsArticle = () => {
  const swiperElement = document.querySelector('[data-swiper="news-article"]');

  if (!swiperElement) return;

  const swiperThumbs = document.querySelector(
    '[data-swiper="news-article-thumbs"]'
  );

  if (!swiperThumbs) return;

  const swiper = new Swiper(swiperThumbs, {
    spaceBetween: 8,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
  });
  const swiper2 = new Swiper(swiperElement, {
    slidesPerView: 1,
    thumbs: {
      swiper: swiper,
    },
  });
};

export {initSwiperNewsArticle};
